import queryString from 'query-string';
import React, { Fragment, useState, useEffect } from 'react';
import BlogCard from '../../shared/cards/BlogCard';
import { EOLocale } from 'eo-locale';
const Listing = ({ nodeId, type }) => {
    const [data, setData] = useState(null);
    useEffect(() => {
        getData();
        async function getData() {
            const query = {
                nodeid: nodeId,
                type: type,
            };
            const res = await fetch(`/api/blog/related/?${queryString.stringify(query)}`);
            if (!res.ok) {
                return;
            }
            const resData = (await res.json());
            setData(resData);
        }
    }, []);
    if (!data) {
        return null;
    }
    return (React.createElement(Fragment, null,
        data.items.length && (React.createElement("section", { className: "standard-banner standard-banner--sub" },
            React.createElement("div", { className: "site-wide grid-container grid-container--full" },
                React.createElement("div", { className: "grid-column" }, type === 'page' ? (React.createElement("h2", null,
                    React.createElement(EOLocale.Text, { id: "xperience.blogpost.pagerelatedarticles" }))) : (React.createElement("h2", null,
                    React.createElement(EOLocale.Text, { id: "xperience.blogpost.contactrelatedarticles" }))))))),
        data.items.length && (React.createElement("div", { className: "site-wide grid-container grid-container--third vert-padding-50" }, data.items.map((item) => (React.createElement(BlogCard, Object.assign({}, item, { key: item.id }))))))));
};
export default Listing;
